<template>
  <div class="wizard-step-theme">
    <ul class="u-reset wizard-step-content__group-list">
      <li
        v-for="(mapThemeList, mapThemeType) in groupedMapThemeList"
        :key="mapThemeType"
        class="wizard-step-theme__group"
      >
        <radio-list
          :items="mapThemeList"
          :title="getMapThemeTypeLabel(mapThemeType)"
          :value.sync="activeThemeId"
        />
      </li>
    </ul>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import { groupBy } from 'lodash-es'
  import { mapThemeTypeList, mapThemeTypeIds } from '../../assets/js/model/map-theme-type'
  import { mapThemeIds, mapThemeList } from '@/assets/js/model/map-theme'
  import RadioList from '@/components/radio-list/radio-list'

  const EXCLUDED_THEME_IDS = [mapThemeIds.WIZARD_STEP_CENTERING, mapThemeIds.SPLASH_SCREEN]
  const EXCLUDED_THEME_TYPE_IDS = [mapThemeTypeIds.PERSONA_WIZARD]

  export default {
    components: { RadioList },
    props: {
      mapConfig: {
        type: Object,
        required: true,
      },
    },
    computed: {
      activeThemeId: {
        get() {
          return this.mapConfig.mapThemeId
        },
        set(mapThemeId) {
          this.setMapConfig({
            ...this.mapConfig,
            mapThemeId,
          })
        },
      },
      filteredMapThemeList() {
        return this.$options.mapThemeList
          .filter(({ id }) => !EXCLUDED_THEME_IDS.includes(id))
          .filter(({ mapThemeType }) => !EXCLUDED_THEME_TYPE_IDS.includes(mapThemeType))
      },
      groupedMapThemeList() {
        return groupBy(this.filteredMapThemeList, ({ mapThemeType }) => mapThemeType)
      },
    },
    methods: {
      ...mapActions('world-map', ['setMapConfig']),
      getMapThemeTypeLabel(mapThemeType) {
        const { label } = mapThemeTypeList.find(({ id }) => id === mapThemeType)
        return this.$t(label)
      },
    },
    mapThemeList,
  }
</script>

<style lang="scss" src="./_wizard-step-theme.scss" />
